"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderNearbyMore = void 0;
var React = require("react");
var DetailPopNearbyTabType_1 = require("../states/DetailPopNearbyTabType");
var renderNearbyMore = function (props) {
    return (React.createElement("div", { className: "c-poplist" },
        React.createElement("dl", null,
            React.createElement("dt", null,
                React.createElement("span", { className: "c-poplist__icon", style: { backgroundColor: '#085963' } }),
                props.t.myPlaces),
            React.createElement("dd", { onClick: function () { return props.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.MYPLACE); } },
                React.createElement("span", { className: "fas fa-star" }),
                props.t.savedPlaces),
            React.createElement("dd", { onClick: function () { return props.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.FAVORITES); } },
                React.createElement("span", { className: "fas fa-heart" }),
                props.t.favorites),
            React.createElement("dd", { onClick: function () { return props.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.HISTORY); } },
                React.createElement("span", { className: "fas fa-history" }),
                props.t.history)),
        React.createElement("dl", null,
            React.createElement("dt", null,
                React.createElement("span", { className: "c-poplist__icon", style: { backgroundColor: '#6b3135' } }),
                props.t.properties),
            React.createElement("dd", { onClick: function () { return props.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.PROPERTIES); } },
                React.createElement("span", { className: "fas fa-building" }),
                props.t.nearbyProperties)),
        React.createElement("dl", null,
            React.createElement("dt", null,
                React.createElement("span", { className: "c-poplist__icon", style: { backgroundColor: '#4971c5' } }),
                props.t.essentials),
            React.createElement("dd", { onClick: function () { return props.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.SCHOOL); } },
                React.createElement("span", { className: "fas fa-school" }),
                props.t.schools),
            React.createElement("dd", { onClick: function () { return props.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.BANK); } },
                React.createElement("span", { className: "fas fa-university" }),
                props.t.banksAtm),
            React.createElement("dd", { onClick: function () { return props.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.HOSPITAL); } },
                React.createElement("span", { className: "fas fa-user-md" }),
                props.t.hospital)),
        React.createElement("dl", null,
            React.createElement("dt", null,
                React.createElement("span", { className: "c-proppopsm__listicon", style: { backgroundColor: '#911eb1' } }),
                props.t.commute),
            React.createElement("dd", { onClick: function () { return props.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.RAILWAY); } },
                React.createElement("span", { className: "fas fa-subway" }),
                props.t.railwaysMtr),
            React.createElement("dd", { onClick: function () { return props.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.BUS); } },
                React.createElement("span", { className: "fas fa-bus" }),
                props.t.busStop)),
        React.createElement("dl", null,
            React.createElement("dt", null,
                React.createElement("span", { className: "c-proppopsm__listicon", style: { backgroundColor: '#bc9408' } }),
                props.t.lifestyle),
            React.createElement("dd", { onClick: function () { return props.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.RESTAURANT); } },
                React.createElement("span", { className: "fas fa-utensils" }),
                props.t.restaurant),
            React.createElement("dd", { onClick: function () { return props.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.STORE); } },
                React.createElement("span", { className: "fas fa-store" }),
                props.t.convenienceStores))));
};
exports.renderNearbyMore = renderNearbyMore;
